import { extendVariants, Tab as HeroTab, Tabs as HeroTabs, TabsProps } from '@heroui/react';
import { twMerge } from 'tailwind-merge';

import { HeroBaseProps } from '../utils';

export const Tabs = extendVariants(
  (
    props: HeroBaseProps<
      TabsProps,
      | 'items'
      | 'isDisabled'
      | 'size'
      | 'disabledKeys'
      | 'selectedKey'
      | 'isVertical'
      | 'onSelectionChange'
      | 'fullWidth'
      | 'variant'
      | 'disabledKeys'
    > & {
      size?: '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
      variant?: Extract<TabsProps['variant'], 'solid' | 'light'>;
    },
  ) => (
    <HeroTabs
      {...props}
      classNames={{
        ...props.classNames,
        tabList: twMerge('gap-1', props.classNames?.tabList),
        tab: twMerge('data-[disabled=true]:opacity-100', props.classNames?.tab),
        cursor: twMerge('shadow-sm', props.classNames?.cursor),
        tabContent: twMerge(
          'shadow-none text-secondary-500 font-medium group-data-[selected=true]:text-secondary-950',
          props.classNames?.tabContent,
        ),
      }}
    />
  ),
  {
    variants: {
      variant: {
        light: {
          tabList: 'bg-none w-full',
          tab: 'max-w-fit bg-none shadow-none font-medium',
          cursor: 'shadow-none bg-transparent',
          base: 'w-full',
        },
        solid: {
          tabList: 'bg-secondary-500/10',
          tab: 'bg-transparent border-none',
          cursor: 'shadow-sm',
        },
      },
      isDisabled: {
        true: {
          tabContent: 'text-secondary-400 group-data-[selected=true]:text-secondary-500',
          cursor: 'shadow-none',
        },
      },
      size: {
        '2xs': {
          tabList: 'rounded-lg',
          tabContent: 'text-xs',
          cursor: 'rounded-md',
          tab: 'py-0.5',
        },
        xs: {
          tabList: 'rounded-lg',
          tabContent: 'text-xs',
          cursor: 'rounded-md',
          tab: 'py-1',
        },
        sm: {
          tabList: 'rounded-lg',
          tabContent: 'text-sm',
          cursor: 'rounded-md',
          tab: 'py-1',
        },
        md: {
          tabList: 'rounded-lg',
          tabContent: 'text-sm',
          cursor: 'rounded-md',
          tab: 'py-1.5',
        },
        lg: {
          tabList: 'rounded-lg',
          tabContent: 'text-sm',
          cursor: 'rounded-lg',
          tab: 'py-2',
        },
        xl: {
          tabList: 'rounded-lg',
          tabContent: 'text-sm',
          cursor: 'rounded-lg',
          tab: 'py-2.5',
        },
        '2xl': {
          tabList: 'rounded-lg',
          tabContent: 'text-sm',
          cursor: 'rounded-lg',
          tab: 'py-3.5',
        },
      },
    },
    compoundVariants: [
      {
        variant: 'light',
        isDisabled: true,
        classNames: {
          cursor: 'shadow-none',
        } as any, // HeroUI types don't support slot objects in compoundVariants yet
      },
      {
        variant: 'solid',
        isDisabled: true,
        class: {
          cursor: 'bg-secondary-200',
        } as any, // HeroUI types don't support slot objects in compoundVariants yet
      },
    ],
    defaultVariants: {
      size: 'sm',
      variant: 'solid',
      isDisabled: false,
    },
  },
);

export const Tab = extendVariants(HeroTab, {});
